import React, { useState, useEffect } from "react";
import {
  ChevronLeft,
  ChevronRight,
  MoveLeft,
  LogIn,
  LogOut,
} from "lucide-react";
import {
  approvaldata,
} from "../../actions/loanAction";
import ArthaContinueButton from "../../fields/ArthaContinueButton";
import Dialog from "@mui/material/Dialog";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { FaArrowLeft } from "react-icons/fa"; // Importing Arrow Left from Font Awesome
import { useSelector, useDispatch } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import AddTimeEntry from "./AddTimeEntry";
import Slide from "@mui/material/Slide";
import { ApproveEntryApi, ApproveSingleEntryApi,FetchTimesheetHoursClickApi } from "../../actioncreators/actioncreators";
import { toast } from "react-toastify";
import ArthaCancelButton from "../../fields/ArthaCancelButton";
import { useSuspension } from "../../contexts/SuspensionContext";

const ApprovalTimeEntries = () => {
  // Suspension check
  const { isSuspended } = useSuspension();
  // Super Admin org filtering support
  const superAdminSelectedOrgId = useSelector((state) => state.superAdminSelectedOrgId);
  const loginResponse = useSelector((state) => state.loginResponse);
  const isSuperAdmin = loginResponse?.role_name?.toUpperCase() === 'SUPER_ADMIN' || loginResponse?.roleName?.toUpperCase() === 'SUPER_ADMIN';

  const fullName = useSelector((state) => state.FetchImage?.fullName) || 'Employee';
  const ApprovalData = useSelector((state) => state.ApprovalData);
  console.log("ApprovalData", ApprovalData);
  const pendingEntries = ApprovalData?.pendingEntries || [];
  const timeEntries = ApprovalData?.timeEntries || [];

  const combinedEntries = [...(pendingEntries || []), ...(timeEntries || [])];
  const filteredEntries = combinedEntries.filter(
    (entry) => entry?.activity_time || entry?.date_and_time
  );

  const FetchWorkedHours = useSelector((state) => state.FetchWorkedHours);
  const [isAddTimeEntryOpen, setIsAddTimeEntryOpen] = useState(false); // Manage dialog visibility
  const timeentries1 = useSelector((state) => state.fetchTimeEntries) || {};

  const timeentries = useSelector(
    (state) => state.fetchTimeEntries?.timeentries
  );
  console.log("timeentries", timeentries1);
  const navigate = useNavigate();

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [selectedEntry, setSelectedEntry] = useState(null); // New state for selected entry
  const [note, setNote] = useState(""); // New state for note input
  const [selectedDay, setSelectedDay] = useState(timeentries1?.weekStart || null);
  const [isDateLoading, setIsDateLoading] = useState(false);

  useEffect(() => {
    if (timeentries1?.weekStart && !selectedDay) {
      handleDateChange(timeentries1.weekStart);
    }
  }, [timeentries1?.weekStart]);

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'N/A';
    return date.toLocaleDateString("en-IN", {
      weekday: "short",
      month: "short",
      day: "numeric",
      timeZone: "Asia/Kolkata",
    });
  };

  function formatToAMPM(dateTime) {
    if (!dateTime) return 'N/A';
    const date = new Date(dateTime);
    if (isNaN(date.getTime())) return 'N/A';

    // Extract hours, minutes, and seconds
    let hours = date.getUTCHours();
    const minutes = date.getUTCMinutes().toString().padStart(2, "0");

    // Determine AM or PM and adjust the hour for 12-hour format
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert 0 or 12+ to 12-hour format

    // Format the time as hh:mm:ss AM/PM
    return `${hours}:${minutes} ${ampm}`;
  }

  const getWeekDays = (startDate) => {
    const days = [];
    // Default to current week if startDate is not provided
    let currentDate;
    if (startDate) {
      currentDate = new Date(startDate);
    } else {
      // Get Monday of current week as default
      currentDate = new Date();
      const dayOfWeek = currentDate.getDay();
      const diff = dayOfWeek === 0 ? -6 : 1 - dayOfWeek; // Adjust to get Monday
      currentDate.setDate(currentDate.getDate() + diff);
    }

    // Validate the date
    if (isNaN(currentDate.getTime())) {
      currentDate = new Date();
      const dayOfWeek = currentDate.getDay();
      const diff = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
      currentDate.setDate(currentDate.getDate() + diff);
    }

    for (let i = 0; i < 7; i++) {
      // Format the day as 'Mon, 21'
      const day = currentDate.toLocaleDateString("default", {
        weekday: "short",
        day: "numeric",
      });
      days.push({
        formattedDay: day,
        fullDate: currentDate.toISOString().split("T")[0], // Store full date in 'YYYY-MM-DD' format
      });
      currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
    }

    return days;
  };

  const weekDays = getWeekDays(timeentries1?.weekStart); // Generate week days dynamically
  const toggleCalendar = () => {
    setIsCalendarOpen(!isCalendarOpen);
  };
  const storedWorkedHours = FetchWorkedHours; // The fetched worked hours array
  const selectedIndex = timeentries1.selectedIndex; // The selected index from the state or prop
  const dayHours = storedWorkedHours?.[selectedIndex] || []; // Get the hours for the selected index, defaulting to an empty array if undefined

  // Retrieve the selected date from localStorage
  const selectedDate = timeentries1?.selectedDate || null;

  const handleAddMemberSuccess = () => {
    setIsAddTimeEntryOpen(false); // Close the dialog after success
  };

  const handleApprove = async () => {
    try {
      const payload = {
        userId: timeEntries?.[0]?.user_id,
        date: timeentries1?.weekStart,
      };
      const response = await ApproveEntryApi(payload);
      if (response.businessStatusCode === 2) {
        toast.success(response?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSingleApprove = async (entryId, type) => {
    try {
      const payload = {
        requestId: [entryId],
        type: type,
      };
      const response = await ApproveSingleEntryApi(payload);
      if (response.businessStatusCode === 2) {
        toast.success(response?.message);
        setSelectedEntry(null); // Close the dialog
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const parseTime = (timeString) => {
    const [hours, minutes] = timeString.match(/\d+/g) || [0, 0];
    return {
      hours: parseInt(hours, 10),
      minutes: parseInt(minutes, 10),
    };
  };

  const handleEntryClick = (entry) => {
    setSelectedEntry(entry);
    setNote(""); // Reset note input
  };

  const handleApproveEntry = () => {
    // Handle approve logic here
    setSelectedEntry(null); // Close the dialog
  };

  const handleRejectEntry = () => {
    // Handle reject logic here
    setSelectedEntry(null); // Close the dialog
  };

  const dispatch = useDispatch();

  const handleDateChange = async (newDate) => {
    setSelectedDay(newDate); // Add this line to update selected day
    const userId = timeEntries?.[0]?.user_id;
    if (!userId) {
      toast.error("User ID not found");
      return;
    }
  
    try {
      setIsDateLoading(true);
      
      // First dispatch the action to update selected date in the store
      dispatch({
        type: 'SET_SELECTED_DATE',
        payload: {
          selectedDate: newDate
        }
      });
      
      // Then fetch the timesheet data for the selected date
      const response = await FetchTimesheetHoursClickApi(newDate, userId);
      
      // Check if response exists and has data
      if (response?.data) {
        dispatch(approvaldata(response.data));
      } else {
        throw new Error('No data received from server');
      }
    } catch (error) {
      console.error("Error fetching timesheet data:", error);
      toast.error("Failed to fetch timesheet data");
    } finally {
      setIsDateLoading(false);
    }
  };

  // Show "Select Organization" message if Super Admin hasn't selected an org
  if (isSuperAdmin && !superAdminSelectedOrgId) {
    return (
      <div className="p-4 bg-gray-50 min-h-screen" style={{ backgroundColor: "#EFF0F4" }}>
        <div className="flex items-center justify-between mb-4">
          <div>
            <h1 className="text-2xl font-bold text-gray-800">Approval Time Entries</h1>
            <p className="text-sm text-gray-1000">Super Admin View</p>
          </div>
        </div>
        <div className="flex flex-col items-center justify-center bg-white rounded-lg shadow-sm p-12 mt-8">
          <svg
            className="w-24 h-24 text-gray-300 mb-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <h2 className="text-xl font-semibold text-gray-700 mb-2">Select an Organization</h2>
          <p className="text-gray-1000 text-center max-w-md">
            Please select an organization from the dropdown in the header to view and approve time entries.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid p-0 m-0" style={{ minHeight: '83vh' }}>
      <div className="row g-0" style={{ backgroundColor: "#EFF0F4", minHeight: '80vh' }}>
        {/* Header - 56px height */}
        <div className="col-12 col-md-12 d-flex align-items-center py-3 px-4 border-bottom "
             style={{ height: '57px' }}>
          <div
            onClick={() => navigate("/home/timesheets")}
            className=" p-1 me-2"
          >
            <MoveLeft size={18} />
          </div>
          <div>
            <h6 className="mb-0">Time Entries</h6>
          </div>
        </div>

        {/* Content area - Subtract header height from viewport */}
        <div className="row g-0">
          {/* Sidebar */}
          <div className="col-12 col-md-3 bg-white border-end" style={{  overflowY: 'auto',msOverflowStyle:'none',scrollbarWidth:'none' }}>
            <div className=" border-0 h-100">
              <div className="card-body p-2 ms-3 mt-3">
                {/* Date Range and Employee Card */}
                <div className="card bg-light border-0 mb-3 shadow-sm border">
                  <div className="card-body p-3">
                    <p className="text-dark mb-1 fw-medium" style={{ fontSize: '14px' }}>
                      {formatDate(timeentries1.weekStart)} - {formatDate(timeentries1.weekEnd)}
                    </p>
                    <div className="d-flex align-items-center" style={{ fontSize: '13px' }}>
                      <span className="text-muted">Employee:</span>
                      <span className="fw-medium ms-2">{fullName}</span>
                    </div>
                  </div>
                </div>

                {/* Timezone Card */}
                <div className="card bg-light border-0 mb-3 shadow-sm border">
                  <div className="card-body p-3">
                    <h6 className="mb-1 " >Timesheet Timezone</h6>
                    <p className="fw-semibold mb-0" style={{ fontSize: '13px' }}>Asia/Calcutta (GMT+5:30)</p>
                  </div>
                </div>

                {/* Hours Summary Card (existing) */}
                <div className="card bg-light border-0 mb-3 shadow-sm border">
                  <div className="card-body p-3" style={{ fontSize: '13px' }}>
                    <div className="d-flex justify-content-between mb-1">
                      <span className="text-muted">Tracked hours</span>
                      <span className="fw-medium">{timeentries1.totalWorkedHours}</span>
                    </div>
                    <div className="d-flex justify-content-between mb-1">
                      <span className="text-muted">Worked hours</span>
                      <span className="fw-medium">{timeentries1.totalWorkedHours}</span>
                    </div>
                    <div className="d-flex justify-content-between mb-1">
                      <span className="text-muted">Breaks</span>
                      <span className="fw-medium">{timeentries1.totalBreakHours || "0h 0m"}</span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span className="text-muted">Overtime</span>
                      <span className="fw-medium">{timeentries1.totalOverTime || "0h 0m"}</span>
                    </div>
                  </div>
                </div>

                <button
                  className="btn w-100 py-2"
                  onClick={isSuspended ? undefined : () => handleApprove()}
                  disabled={isSuspended}
                  title={isSuspended ? "Actions are disabled - organization is suspended" : ""}
                  style={{
                    backgroundColor: isSuspended ? "#ccc" : "#fd5f07",
                    color: "white",
                    cursor: isSuspended ? "not-allowed" : "pointer",
                    opacity: isSuspended ? 0.6 : 1,
                  }}
                >
                  Approve All Entries
                </button>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="col-12 col-md-9 align-items-center justify-content-center" style={{ height: '74vh' }}>
            <div className="card border-0 h-100">
              {/* Week Navigation - 64px height */}
              <div className="card-header bg-white py-3 px-4 border-bottom" 
                   style={{ height: '64px' }}>
                <div className="d-flex align-items-center">
                  {/* <button 
                    className="btn p-1"
                    onClick={() => {
                      const prevDate = new Date(selectedDate);
                      prevDate.setDate(prevDate.getDate() - 1);
                      const formattedDate = prevDate.toISOString().split('T')[0];
                      handleDateChange(formattedDate);
                    }}
                  >
                    <ChevronLeft size={16} />
                  </button> */}
                  <div className="d-flex flex-grow-1 justify-content-around">
                    {weekDays.map((day, index) => {
                      const isSelected = selectedDay === day.fullDate || 
                        (!selectedDay && index === 0); // Add this condition
                      return (
                        <div
                          key={day.formattedDay}
                          className={`text-center px-1 cursor-pointer`}
                          onClick={() => handleDateChange(day.fullDate)}
                          style={{ 
                            cursor: 'pointer',
                            borderBottom: isSelected ? '2px solid #fd5f07' : 'none',
                            paddingBottom: '8px'
                          }}
                        >
                          <div 
                            className={`${isSelected ? 'text-orange' : 'text-muted'}`} 
                            style={{ fontSize: '13px', color: isSelected ? '#fd5f07' : undefined }}
                          >
                            {day.formattedDay}
                          </div>
                          <div 
                            className={`${isSelected ? 'fw-medium' : ''}`}
                            style={{ 
                              fontSize: '13px',
                              color: isSelected ? '#fd5f07' : undefined
                            }}
                          >
                            {dayHours[index] || "0h 0m"}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  {/* <button 
                    className="btn p-1"
                    onClick={() => {
                      const nextDate = new Date(selectedDate);
                      nextDate.setDate(nextDate.getDate() + 1);
                      const formattedDate = nextDate.toISOString().split('T')[0];
                      handleDateChange(formattedDate);
                    }}
                  >
                    <ChevronRight size={16} />
                  </button> */}
                </div>
              </div>

              {/* Time Entries List - Subtract header and navigation heights */}
              <div className="card-body p-0" 
                   style={{ 
                     height: 'calc(100vh - 56px - 64px)',
                     overflowY: 'auto'
                   }}>
                {isDateLoading ? (
                  <div className="d-flex justify-content-center align-items-center h-100">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : isLoading ? (
                  <div className="text-center py-4">Loading...</div>
                ) : error ? (
                  <div className="text-center py-4 text-danger">{error}</div>
                ) : filteredEntries.length === 0 ? (
                  <div className="d-flex justify-content-center align-items-center h-100">
                    <p className="text-muted">No Data Found</p>
                  </div>
                ) : (
                  filteredEntries.map((entry) => {
                    // Helper function to format remarks for display
                    const formatRemark = (remark) => {
                      if (!remark) return null;
                      // Convert snake_case to Title Case
                      return remark.split('_').map(word => 
                        word.charAt(0) + word.slice(1).toLowerCase()
                      ).join(' ');
                    };

                    // Helper function to get remark badge color
                    const getRemarkBadgeColor = (remark) => {
                      if (!remark) return {};
                      
                      const remarkLower = remark.toLowerCase();
                      if (remarkLower.includes('violation') || remarkLower.includes('voilation')) {
                        return { backgroundColor: '#fee2e2', color: '#991b1b', borderColor: '#fca5a5' };
                      } else if (remarkLower.includes('schedule') || remarkLower.includes('time')) {
                        return { backgroundColor: '#fef3c7', color: '#92400e', borderColor: '#fcd34d' };
                      } else if (remarkLower.includes('late')) {
                        return { backgroundColor: '#ffedd5', color: '#9a3412', borderColor: '#fdba74' };
                      } else if (remarkLower.includes('early')) {
                        return { backgroundColor: '#dbeafe', color: '#1e40af', borderColor: '#93c5fd' };
                      }
                      return { backgroundColor: '#f3f4f6', color: '#374151', borderColor: '#d1d5db' };
                    };

                    // Debug log
                    if (entry.remarks) {
                      console.log("Approval Entry with remarks:", entry.remarks);
                    }

                    return (
                    <div
                      key={entry.activity_id || entry.id}
                      className="border-bottom"
                    >
                      <div className="d-flex align-items-center px-4 py-2">
                        <div className={`rounded-circle p-2 me-3`}
                             style={{ backgroundColor: entry.activity_type === "CHECKIN" ? '#E8F5E9' : '#FFEBEE' }}>
                          {entry.activity_type === "CHECKIN" ? (
                            <LogIn size={16} style={{ color: '#2E7D32' }} />
                          ) : (
                            <LogOut size={16} style={{ color: '#C62828' }} />
                          )}
                        </div>
                        <div className="flex-grow-1" style={{ fontSize: '13px' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
                            {/* Display Remarks Badge inline before activity */}
                            {entry.remarks && (
                              <span 
                                style={{
                                  ...getRemarkBadgeColor(entry.remarks),
                                  fontSize: '9px',
                                  fontWeight: '600',
                                  padding: '2px 6px',
                                  borderRadius: '4px',
                                  display: 'inline-block',
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.5px',
                                  lineHeight: '1.2'
                                }}
                              >
                                {formatRemark(entry.remarks)}
                              </span>
                            )}
                            <span className="text-muted" style={{ margin: 0, fontSize: '13px' }}>
                              {entry.activity_type === "CHECKIN" ? "Clock in at " : "Clock out at "}
                              {formatToAMPM(entry.date_and_time || entry.activity_time)}
                            </span>
                          </div>
                        </div>
                        {entry.status === "PENDING" && (
                          <ArthaContinueButton
                           
                            onClick={() => handleEntryClick(entry)}
                            style={{
                              
                              cursor: "pointer",
                              width: "15%",
                             height:'4vh',
                            }}
                          >
                            View Entry
                          </ArthaContinueButton>
                        )}
                      </div>
                    </div>
                  );
                  })
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Dialogs with updated styling */}
      <Dialog
        TransitionComponent={Transition}
        open={isAddTimeEntryOpen}
        onClose={() => setIsAddTimeEntryOpen(false)}
        maxWidth="sm"
        fullWidth
        aria-hidden={!isAddTimeEntryOpen}
        inert={!isAddTimeEntryOpen ? "true" : undefined}
      >
        <AddTimeEntry
          isOpen={isAddTimeEntryOpen}
          onClose={() => setIsAddTimeEntryOpen(false)}
          onSuccess={handleAddMemberSuccess}
          className="bg-white border p-0 m-0"
        />
      </Dialog>
      <Dialog
        open={!!selectedEntry}
        onClose={() => setSelectedEntry(null)}
        maxWidth="sm"
        fullWidth
      >
        <div className="p-3">
          <div className="pb-2">
            <span className="fw-medium">Entry Details</span>
          </div>
          <hr className="my-2" />
          {selectedEntry && (
            <>
              <div className="py-2" style={{ fontSize: '13px' }}>
                <p className="mb-2">
                  <strong>Date and Time: </strong> 
                  <span>
                  {formatDate(selectedEntry.date_and_time || selectedEntry.activity_time)}
                  &nbsp;,&nbsp;
                  {formatToAMPM(selectedEntry.date_and_time || selectedEntry.activity_time)}
                  </span>
                </p>
                <p className="mb-2">
                  <strong>Entry Type:</strong><span> Manual</span> 
                </p>
                <input
                  type="text"
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                  placeholder="Add a note"
                  className="form-control form-control-sm mb-3"
                />
                <div className="d-flex justify-content-end gap-2">
                  <ArthaCancelButton
                    className="btn btn-sm"
                    onClick={isSuspended ? undefined : () => handleSingleApprove(selectedEntry.id, 'REJECTED')}
                    disabled={isSuspended}
                    style={isSuspended ? { opacity: 0.5, cursor: "not-allowed" } : {}}
                    title={isSuspended ? "Actions are disabled - organization is suspended" : ""}
                  >
                    Reject
                  </ArthaCancelButton>
                  <ArthaContinueButton
                    className="btn btn-sm"
                    onClick={isSuspended ? undefined : () => handleSingleApprove(selectedEntry.id, 'APPROVED')}
                    disabled={isSuspended}
                    style={isSuspended ? { opacity: 0.5, cursor: "not-allowed" } : {}}
                    title={isSuspended ? "Actions are disabled - organization is suspended" : ""}
                  >
                    Approve
                  </ArthaContinueButton>
                </div>
              </div>
            </>
          )}
        </div>
      </Dialog>
    </div>
  );
};

export default ApprovalTimeEntries;

